import {
  TOGGLE_OPTION,
  TOGGLE_OPTION_CONFLICT,
  TOGGLE_OPTION_CONFLICT_RESOLVE,
  TOGGLE_OPTION_CONFLICT_CANCEL
} from '../actionTypes';

export default function conflictOption(state, action) {
  switch (action.type) {
    case TOGGLE_OPTION_CONFLICT:
      return action.payload.option;
    case TOGGLE_OPTION:
    case TOGGLE_OPTION_CONFLICT_RESOLVE:
    case TOGGLE_OPTION_CONFLICT_CANCEL:
      return null;
    default:
      return state || null;
  }
}
